/**
 * Oferta de ítems = porcentaje (0–100). OfertaDeVariable = oferta solo de esa variante.
 */

export function clampOfferPercent(value) {
  const n = parseFloat(value);
  if (Number.isNaN(n) || n <= 0) return 0;
  return Math.min(100, n);
}

export function applyOfferPercent(price, offerPercent) {
  const p = parseFloat(price);
  if (Number.isNaN(p) || p < 0) return 0;
  const pct = clampOfferPercent(offerPercent);
  if (!pct) return Math.round(p * 100) / 100;
  return Math.round(p * (1 - pct / 100) * 100) / 100;
}

export function applyProductDiscountPercent(price, discountPercent) {
  return applyOfferPercent(price, discountPercent);
}

export function resolveEffectiveOfferPercent(itemOferta, variantOferta) {
  let variantRaw = variantOferta;
  if (variantOferta != null && typeof variantOferta === 'object') {
    variantRaw = variantOferta.oferta_variante ?? variantOferta.OfertaDeVariable ?? 0;
  }
  const variantPct = clampOfferPercent(variantRaw);
  if (variantPct > 0) return variantPct;
  return clampOfferPercent(itemOferta);
}

export function computeItemUnitPrice({
  listPrice,
  itemOferta = 0,
  variantOferta = 0,
  productDiscountPercent = 0,
}) {
  const list = parseFloat(listPrice);
  const base = Number.isNaN(list) || list < 0 ? 0 : list;
  const offerPct = resolveEffectiveOfferPercent(itemOferta, variantOferta);
  const afterOffer = applyOfferPercent(base, offerPct);
  const final = applyProductDiscountPercent(afterOffer, productDiscountPercent);
  return {
    listPrice: Math.round(base * 100) / 100,
    offerPercent: offerPct,
    finalPrice: final,
    hasOffer: offerPct > 0,
  };
}
